import React from 'react';
import { scenarios, HUMANS } from '../../data/populations';
import { useScenario } from '../../contexts/ScenarioContext';
import { getSourceById } from '../../utils/sourceIndex';
import { formatCompact, formatRatio } from '../../utils/format';
import { SourceRef } from '../SourceRef';
export function ScenarioSwitcher() {
  const {
    scenarioId,
    setScenarioId
  } = useScenario();
  return <div data-id="element-103" data-mp="3pghm2sdm6iwh">
      <p id="scenario-label" className="font-mono text-[11px] uppercase tracking-[0.16em] text-muted" data-id="element-104" data-mp="3pgrdmkeb4y4a">
        Scenario — what counts as a machine
      </p>
      <div role="radiogroup" aria-labelledby="scenario-label" className="mt-3 grid gap-2 sm:grid-cols-3" data-id="element-105" data-mp="3ucpvrq91ljw9">
        {scenarios.map(s => {
        const active = s.id === scenarioId;
        return <div key={s.id} className="group relative" data-id="element-106" data-mp="c135fzsdmt14">
              <button type="button" role="radio" aria-checked={active} onClick={() => setScenarioId(s.id)} className={`flex w-full flex-col items-start rounded-md border px-4 py-3 text-left transition-[background-color,border-color] duration-150 ease-out ${active ? 'border-machine bg-machine/10' : 'border-line bg-surface hover:border-faint'}`} data-id="element-107" data-mp="c2eby7d7ievx">
                <span className={`whitespace-nowrap text-sm font-medium ${active ? 'text-ink' : 'text-ink/85'}`} data-id="element-108" data-mp="sodoq6rqiscj">{s.label}</span>
                <span className="mt-1 flex w-full items-baseline justify-between gap-3 font-mono text-[12px]" data-id="element-109" data-mp="1qat678k5vq03">
                  <span className={active ? 'text-machine' : 'text-muted'} data-id="element-110" data-mp="1lecmcqjzvxst">~{formatCompact(s.count)}</span>
                  <span className="text-muted" data-id="element-111" data-mp="1gjgjswh4ts1g">{formatRatio(s.count / HUMANS.base)} : 1</span>
                </span>
              </button>
              <div className="invisible absolute left-0 right-0 top-full z-30 translate-y-1 pt-2 opacity-0 transition-[opacity,transform,visibility] duration-150 ease-out group-focus-within:visible group-focus-within:translate-y-0 group-focus-within:opacity-100 group-hover:visible group-hover:translate-y-0 group-hover:opacity-100" data-id="element-112" data-mp="292c81c2g8y0j">
                <div className="rounded-md border border-line bg-raised p-3 shadow-2xl shadow-black/60" data-id="element-113" data-mp="6enjd9pd4vxz">
                  <p className="text-[12.5px] leading-snug text-ink/90" data-id="element-114" data-mp="3oswe4qxmhm74">{s.description}</p>
                  <p className="mt-2 font-mono text-[11px] text-machine" data-id="element-115" data-mp="3tqogkevw8qpk">
                    Estimate · range {formatCompact(s.low)}–{formatCompact(s.high)}
                  </p>
                  <p className="mt-2 font-mono text-[10px] uppercase tracking-wider text-muted" data-id="element-116" data-mp="3jv4m7wwza02x">Sources</p>
                  <ul className="mt-1 space-y-0.5" data-id="element-117" data-mp="35vlrq6x3an93">
                    {s.sourceIds.map(id => <li key={id} className="text-[12px] text-muted" data-id="element-118" data-mp="3au6jdhy9zylx">
                        {getSourceById(id)?.publisher}
                        <SourceRef id={id} data-id="element-119" data-mp="140ul8bua8a6n" />
                      </li>)}
                  </ul>
                </div>
              </div>
            </div>;
      })}
      </div>
    </div>;
}